var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.dados } },
        [
          _c("el-table-column", {
            attrs: {
              label: "Processo",
              prop: "numeroProcesso",
              width: "130",
              fixed: "fixed"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Interessado",
              prop: "nomeRazaoSocialInteressado",
              width: "200",
              fixed: "fixed"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "CPF", prop: "cpfCnpjInteressado", width: "130" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Ordem de serviço",
              prop: "ordensServico",
              width: "180"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Município",
              prop: "municipioFormatado",
              width: "100%"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "Endereço", prop: "loteamentoVila", width: "200" }
          }),
          _c("el-table-column", {
            attrs: { label: "Bairro", prop: "bairro", width: "130" }
          }),
          _c("el-table-column", {
            attrs: { label: "Lote", width: "100%", prop: "lote" }
          }),
          _c("el-table-column", { attrs: { label: "Quadra", prop: "quadra" } }),
          _c("el-table-column", {
            attrs: { label: "Cadastrante", prop: "cadastrante", width: "200" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Perfil do cadastrante",
              prop: "perfilCadastrante",
              width: "155"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Data",
              prop: "dataFormatada",
              width: "100%",
              align: "center"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Ações",
              align: "center",
              width: "100%",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          { attrs: { type: "primary", size: "small" } },
                          [
                            _vm._v("Ações"),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right"
                            })
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c("el-dropdown-item", [
                              _c(
                                "div",
                                {
                                  staticClass: "flex",
                                  on: {
                                    click: function($event) {
                                      return _vm.abreModal(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-eye" }),
                                  _vm._v("  Visualizar processo")
                                ]
                              )
                            ]),
                            _c("el-dropdown-item", [
                              _c(
                                "div",
                                {
                                  staticClass: "flex",
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadPdf(scope.row)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-download" }),
                                  _vm._v("  Baixar PDF")
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.showModalVisualizarProcesso
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96675f70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96675f70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/components/ListagemProcesso.vue
// module id = null
// module chunks = 